// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ig-1";
export var quotedThread = "_ig-0";